/** Default UI and playback language across the app. */
export const DEFAULT_LANGUAGE = 'te';

export const LANGUAGE_LABELS = {
  en: 'English',
  hi: 'Hindi',
  te: 'Telugu'
};

export function languageLabel(code) {
  return LANGUAGE_LABELS[code] || LANGUAGE_LABELS[DEFAULT_LANGUAGE];
}
